<template>
  <v-container class="fill-height position-relative" fluid>
    <!-- language switcher -->
    <div class="lang-switch">
      <LanguageSwitcher />
    </div>

    <v-row class="h-100" justify="center" align="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <div class="text-center d-flex align-center justify-center flex-column">
          <h1 class="mb-2">404</h1>
          <p class="text-medium-emphasis mb-6">{{ t('notFound.message') }}</p>

          <router-link
            to="/dashboard"
            class="text-caption text-primary text-decoration-none d-inline-flex align-center"
          >
            <v-icon size="18" class="mr-1">mdi-arrow-left</v-icon>
            {{ t('notFound.back') }}
          </router-link>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { useI18n } from 'vue-i18n'
import LanguageSwitcher from '@/components/LanguageSwitcher.vue'

export default {
  name: 'NotFound',
  components: { LanguageSwitcher },
  setup() {
    const { t } = useI18n()
    return { t }
  }
}
</script>

<style scoped>
.position-relative { position: relative; }
.lang-switch {
  position: absolute;
  top: 8px;
  right: 8px;
}
</style>
